import React from 'react';

function LeftBarTitle({ text }) {
	return <p className="text-xl 2k:text-2xl text-slate-100 font-bold mb-2 2k:mb-6 mt-6 2k:mt-12 text-center">{text}</p>;
}

export default LeftBarTitle;
